import { pickBy } from 'lodash';
export var sliceFontTypes = function (entity) {
  var bodyFontType = entity.bodyFontType,
    headerFontType = entity.headerFontType;
  return pickBy({
    body: bodyFontType === null || bodyFontType === void 0 ? void 0 : bodyFontType.internalName,
    header: headerFontType === null || headerFontType === void 0 ? void 0 : headerFontType.internalName
  });
};